export const RATIO_PRESETS = [
  { key: "16:9", value: 16 / 9, label: "16:9", styleKey: "ratio_style.standard" },
  { key: "4:3", value: 4 / 3, label: "4:3", styleKey: "ratio_style.classic" },
  { key: "1:1", value: 1, label: "1:1", styleKey: "ratio_style.square" },
  { key: "9:16", value: 9 / 16, label: "9:16", styleKey: "ratio_style.reels" },
  { key: "4:5", value: 4 / 5, label: "4:5", styleKey: "ratio_style.ig_portrait" },
];

export const DEFAULT_RATIO_KEY = "16:9";
export const DEFAULT_RATIO_VALUE = 16 / 9;

const EPSILON = 0.0001;

export function getPresetFromValue(canvasRatio) {
  if (typeof canvasRatio !== "number" || !isFinite(canvasRatio)) return null;
  const found = RATIO_PRESETS.find((p) => Math.abs(p.value - canvasRatio) < EPSILON);
  return found ? found.key : null;
}

export function getValueFromPreset(ratioKey) {
  const found = RATIO_PRESETS.find((p) => p.key === ratioKey);
  return found ? found.value : null;
}
